import React from 'react'
import { isArray } from 'lodash'
import { Glyphicon, Label, Tooltip, OverlayTrigger } from "react-bootstrap"

import { getText } from '../../lib/text.js'


export const WarningSmall = ({ warning }: { warning: string[]|string}) => (
  !warning
    ? <span />
    : (
      <OverlayTrigger
        placement="right"
        overlay={(
          <Tooltip id={getText("Problemas con este item")} style={{ fontSize: 15 }}>
            {
              isArray(warning)
                ? <ul>{warning.map(x => <li key={x}>{getText(x)}</li>)}</ul>
                : getText(warning)
            }
          </Tooltip>
        )}
      >
        <Label bsStyle="warning"><Glyphicon glyph="warning-sign" /></Label>
      </OverlayTrigger>
    )
)

const EachWarning = ({ warning }) => (
  <Label bsStyle="warning" style={{ display: "inline-block" }}>
    <Glyphicon glyph="warning-sign" />
    <span style={{ marginLeft: 8 }}>{getText(warning)}</span>
  </Label>
)

export const Warning = ({ warning }) => (
  <div className="ItemWarning">
    {
      (isArray(warning) 
        ? warning 
        : [ warning ]).map(w => <EachWarning warning={w} />)
    }
  </div>
)

export default Warning